import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeadsService } from './services/leads.service';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    LeadsService
  ]
})
export class LeadsModule { }
